// Phase 6 T35 — 15-line bridge for `report.empty_state_shown`. Mounted on
// each empty-state partial; on connect(), dispatches a window event that
// the body-mounted engine-telemetry controller listens for.
//
// [v1.1 FIX #18] — adding `engine-telemetry` directly to the empty-state
// partial would fire a duplicate body-controller instance and double-mount
// the queue.
//
// [Phase 7 T43 / FE I-1] — sessionStorage de-dup gate. Turbo Drive cache
// restores re-mount this controller on back-nav, which previously
// double-fired the event. The gate uses a per-tab sessionStorage key so
// (a) cross-tab navigation still emits once per tab and (b) closing the
// tab clears the gate (sessionStorage lifetime = tab session; survives
// reloads, isolated across tabs).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { event: String, properties: Object }

  connect() {
    const props = this.propertiesValue || {}
    const surface = props.surface || "unknown"
    const key = `engine_empty_state_seen:${this.eventValue}:${surface}`

    try {
      if (window.sessionStorage.getItem(key) === "1") return
      window.sessionStorage.setItem(key, "1")
    } catch (_e) {
      // sessionStorage unavailable (Safari Private Mode, disabled storage).
      // Fall through and emit — accept the rare double-fire over silent loss.
    }

    window.dispatchEvent(new CustomEvent("engine-telemetry:emit", {
      detail: { eventType: this.eventValue, properties: props }
    }))
  }
}
